import React, { useContext, useMemo, useState } from "react";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import { AuthContext } from "../../context/Auth/AuthContext";
import OperationalDayView from "./views/OperationalDayView";
import TechnicianDayView from "./views/TechnicianDayView";
import OsDailyReportView from "./views/OsDailyReportView";
import ImplantationView from "./views/implantation";

const DASHBOARD_VIEWS = [
  {
    id: "os-daily-report",
    label: "Relatório diário de OS",
    component: OsDailyReportView
  },
  {
    id: "implantation",
    label: "Implantação",
    component: ImplantationView
  },
  {
    id: "technician-day",
    label: "Visão do técnico",
    component: TechnicianDayView
  },
  {
    id: "operational-day",
    label: "Visão operacional do dia",
    component: OperationalDayView,
    adminOnly: true
  }
];

const useStyles = makeStyles(theme => ({
  mainContainer: {
    padding: theme.spacing(2),
    fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
    "& .MuiTypography-root, & .MuiInputBase-root, & .MuiButton-root": {
      fontFamily: "inherit"
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1)
    }
  },
  header: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    flexWrap: "wrap"
  },
  heading: {
    minWidth: 220
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: 13,
    marginTop: -2
  },
  viewSelect: {
    minWidth: 260,
    marginLeft: "auto",
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      marginLeft: 0,
      width: "100%"
    }
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    paddingRight: 2,
    ...theme.scrollbarStyles
  }
}));

const Dashboard = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const isAdmin = user?.profile === "admin";
  const availableViews = useMemo(
    () => DASHBOARD_VIEWS.filter(view => !view.adminOnly || isAdmin),
    [isAdmin]
  );
  const [selectedView, setSelectedView] = useState("technician-day");
  const selectedAvailableView = availableViews.some(
    view => view.id === selectedView
  )
    ? selectedView
    : "technician-day";
  const view = availableViews.find(item => item.id === selectedAvailableView);
  const ViewComponent = view.component;

  return (
    <MainContainer maxWidth={false} className={classes.mainContainer}>
      <MainHeader>
        <div className={classes.header}>
          <div className={classes.heading}>
            <Title>Dashboard</Title>
            <div className={classes.subtitle}>
              Acompanhe a operação por diferentes visões
            </div>
          </div>

          <FormControl
            variant="outlined"
            size="small"
            className={classes.viewSelect}
          >
            <InputLabel id="dashboard-view-label">Visão</InputLabel>
            <Select
              labelId="dashboard-view-label"
              value={selectedAvailableView}
              onChange={event => setSelectedView(event.target.value)}
              label="Visão"
            >
              {availableViews.map(item => (
                <MenuItem key={item.id} value={item.id}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </MainHeader>

      <div className={classes.content}>
        <ViewComponent />
      </div>
    </MainContainer>
  );
};

export default Dashboard;
